import { slideDown } from './slideUpDown';
import { slideUp } from './slideUpDown';

export const submenuMobile = () => {
    const menu = document.querySelector('.submenu-mobile');

    if (menu) {
        const button = menu.querySelector('.submenu-mobile__item--current');
        const dropdown = menu.querySelector('.submenu-mobile__dropdown');

        button.addEventListener('click', () => {
            menu.classList.toggle('submenu-mobile--active');

            if (menu.classList.contains('submenu-mobile--active')) {
                slideDown(dropdown);
            } else {
                slideUp(dropdown);
            }
        });

    }
};
